import { HrObjectType } from './HrObjectType';

export const HrObjectTypeMatchKeys = {
	[HrObjectType.Users]: [
		{
			source: 'id',
			target: 'matchedId',
			name: 'Id'
		},
		{
			source: 'code',
			target: 'matchedCode',
			name: 'Code'
		},
		{
			source: 'name',
			target: 'matchedName',
			name: 'Name'
		}
	],
	[HrObjectType.Positions]: [
		{
			source: 'id',
			target: 'matchedId',
			name: 'Id'
		},
		{
			source: 'code',
			target: 'matchedCode',
			name: 'Code'
		},
		{
			source: 'name',
			target: 'matchedName',
			name: 'Name'
		}
	],
	[HrObjectType.Department]: [
		{
			source: 'id',
			target: 'matchedId',
			name: 'Id'
		},
		{
			source: 'code',
			target: 'matchedCode',
			name: 'Code'
		},
		{
			source: 'name',
			target: 'matchedName',
			name: 'Name'
		}
	],
	[HrObjectType.Professions]: [
		{
			source: 'id',
			target: 'matchedId',
			name: 'Id'
		},
		{
			source: 'code',
			target: 'matchedCode',
			name: 'Code'
		},
		{
			source: 'name',
			target: 'matchedName',
			name: 'Name'
		}
	],
	[HrObjectType.Groups]: [
		{
			source: 'id',
			target: 'matchedId',
			name: 'Id'
		},
		{
			source: 'code',
			target: 'matchedCode',
			name: 'Code'
		},
		{
			source: 'name',
			target: 'matchedName',
			name: 'Name'
		}
	],
	[HrObjectType.PropertyTypes]: [
		{
			source: 'id',
			target: 'matchedId',
			name: 'Id'
		},
		{
			source: 'code',
			target: 'matchedCode',
			name: 'Code'
		},
		{
			source: 'name',
			target: 'matchedName',
			name: 'Name'
		}
	],
	[HrObjectType.ManagerKeys]: [
		{
			source: 'id',
			target: 'matchedId',
			name: 'Id'
		},
		{
			source: 'description',
			target: 'matchedDescription',
			name: 'Description'
		},
		{
			source: 'importStatus',
			target: 'matchedImportStatus',
			name: 'ImportStatus'
		}
	]
};
